import { createFileRoute } from '@tanstack/react-router';
import { ContactSection } from '../../components/contacts/ContactSection';

export const Route = createFileRoute('/_auth/employees')({
  component: () => <ContactSection contactType="employee" titlePlural="Employees" titleSingular="employee" />,
});
